import React, { useState, useEffect } from "react";
import { ContentTable } from "./ContentTable";
import { formatNumber } from "utils/currencyFormat";
import Pagination from "react-js-pagination";
import { ThemMoiTaiSanCongTy } from "components/CommonComponent/ThemMoiTaiSanCongTy";

export const TableDanhSach = ({
  dataDanhSach,
  dataSearch,
  setDataSearch,
  onSearch,
  handlePageChange,
}) => {
  const [showModal, setShowModal] = useState(false);

  const handleClose = () => setShowModal(false);
  const handleShow = () => setShowModal(true);

  const TotalQuantity = dataDanhSach.TotalQuantity;
  return (
    <>
      <div
        className="card border-light mb-3 card-v2"
        style={{
          marginLeft: "15px",
          marginRight: "15px",
        }}
      >
        <div className="card-body card-body-v2">
          <div className="Left808x200 Table-main-new">
            <button
              type="button"
              className="btn btn-border-new"
              onClick={handleShow}
            >
              <span>
                <img
                  src="/app-assets/images/icon-them-moi-cam-do-v2.png"
                  style={{ paddingBottom: "5px" }}
                />{" "}
                Thêm mới
              </span>
            </button>
            <div className="table-mobile  table-mobile-hover table-responsive-new ">
              <div className="custom-table-wrapper">
                <div
                  className="table-headers"
                  style={{
                    position: "sticky",
                    padding: "2px",
                    top: "0rem",
                    zIndex: "999",
                    background: "#FFFFFF",
                    padding: "1px 0",
                  }}
                >
                  <div className="custom-table-header flex-basis-5 flex-basis-5-sm">
                    <p className="text-center">
                      STT
                      <br />{" "}
                      <span className="color-do-bold">
                        [ {dataDanhSach.TotalQuantity} ]
                      </span>
                    </p>
                  </div>
                  <div className="custom-table-header flex-basis-10 flex-basis-10-sm">
                    <p className="tab-header  text-center">Mã tài sản</p>
                  </div>
                  <div className="custom-table-header flex-basis-15 flex-basis-15-sm">
                    <p className="text-center">Tên tài sản</p>
                  </div>
                  <div className="custom-table-header flex-basis-15 flex-basis-15-sm">
                    <p className="text-right">
                      Giá
                      <br />
                      <span className="color-do-bold text-right">
                        {formatNumber(dataDanhSach.tongGiaTri)}
                      </span>
                    </p>
                  </div>
                  <div className="custom-table-header flex-basis-15 flex-basis-15-sm">
                    <p className="text-right">
                      Đã khấu hao
                      <br />
                      <span className="color-do-bold text-right">
                        {formatNumber(dataDanhSach.tongDaKhauHao)}
                      </span>
                    </p>
                  </div>
                  <div className="custom-table-header flex-basis-18 flex-basis-18-sm">
                    <p className="text-right">
                      Giá trị còn lại
                      <br />
                      <span className="color-do-bold text-right">
                        {formatNumber(
                          dataDanhSach.tongGiaTri - dataDanhSach.tongDaKhauHao,
                        )}
                      </span>
                    </p>
                  </div>
                  <div className="custom-table-header flex-basis-7 flex-basis-7-sm">
                    <p className="text-left">Hiện Trạng</p>
                  </div>
                  <div className="custom-table-header flex-basis-10 flex-basis-10-sm">
                    <p className="text-left">Kho</p>
                  </div>
                  <div className="custom-table-header flex-basis-5 flex-basis-5-sm">
                    <p className="text-left">Thao tác</p>
                  </div>
                </div>

                <div className="custom-table-body">
                  {dataDanhSach != undefined && (
                    <ContentTable
                      listDataDanhSach={dataDanhSach.DanhSach}
                      onSearch={onSearch}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="card mb-3 border-light mb-1 card-v2"
        style={{
          marginLeft: "15px",
          marginRight: "15px",
        }}
      >
        <div className="card-body card-body-v2">
          <div className="row">
            <div className="col-sm-12  col-md-6">
              <span className="color7">
                {TotalQuantity === 0 ? (
                  "Hiển thị 0 - 0 / Tổng số 0"
                ) : (
                  <>
                    Hiển thị{" "}
                    {(dataSearch.pageIndex - 1) * dataSearch.pageSize + 1} -{" "}
                    {Math.min(
                      dataSearch.pageIndex * dataSearch.pageSize,
                      TotalQuantity,
                    )}{" "}
                    / Tổng số {TotalQuantity}
                  </>
                )}
              </span>
            </div>
            <div className="col-sm-12 col-md-6">
              <div
                className={
                  "paniation-new paniation-new1 d-flex justify-content-center " +
                  (TotalQuantity === 0 ? "hidden" : "")
                }
                style={{ float: "right" }}
              >
                <nav aria-label="Page navigation">
                  <Pagination
                    activePage={dataSearch.pageIndex}
                    itemsCountPerPage={dataSearch.pageSize}
                    totalItemsCount={TotalQuantity}
                    pageRangeDisplayed={5}
                    onChange={handlePageChange}
                    itemClass="page-item border-none"
                    linkClass="page-link border-none"
                    activeClass="active"
                  />
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>
      {showModal && (
        <ThemMoiTaiSanCongTy
          show={showModal}
          onHide={handleClose}
          TaiSanID={0}
          onSearch={onSearch}
        />
      )}
    </>
  );
};
